import React, { useEffect } from 'react';
import './PolicyModal.css';

const PolicyModal = ({ title, children, open, onClose }) => {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="policy-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onMouseDown={(e) => {
        // Close only if clicking the overlay, not the card
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="policy-modal">
        <div className="policy-modal-header">
          <h4>{title}</h4>
          <button type="button" className="policy-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="policy-modal-body">{children}</div>

        <div className="policy-modal-actions">
          <button type="button" className="policy-modal-ok" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
